import type Api from 'Api'

import { ref } from 'vue'
import type { WidgetConfiguration } from '@/models'

export const useWidgetConfigurationStore = defineStore(
  'widgetConfiguration.store',
  () => {
    const layoutStore = useLayoutStore()
    const widgetConfiguration = ref<WidgetConfiguration>()
    const errors = ref<Record<string, Api.ThrowingError[]>>({
      widgetConfiguration: [],
    })
    const isInitialized = ref<boolean>(false)

    const widgetIntegrationsKeys = computed(
      () =>
        widgetConfiguration.value?.layoutConfig?.integrations
          ?.advertisingCounters,
    )

    const widgetCustomStylesLinks = computed(
      () =>
        Array.isArray(widgetConfiguration.value?.themeConfig.customStyles) &&
        !!widgetConfiguration.value?.themeConfig.customStyles.length &&
        widgetConfiguration.value?.themeConfig.customStyles,
    )

    const getByCredentials = async (apiKey: string, domain?: string) => {
      try {
        const { $api } = useNuxtApp()

        const widgetSettings =
          await $api.resources.widgetConfiguration.getByParams(apiKey, domain)

        if (widgetSettings && widgetSettings.data) {
          // получаем в том числе ключи счетчиков виджета (ga, gtm, gtm4, ym)
          widgetConfiguration.value = widgetSettings.data
          layoutStore.layoutSettings = {
            settings: widgetSettings.data?.layoutConfig?.settings,
          }
        }
      } catch (error) {
        errors.value.widgetConfiguration.push(<Api.ThrowingError>error)
      }
    }

    const getApiKey = () => widgetConfiguration.value?.apiKey || undefined

    return {
      widgetConfiguration,
      errors,
      widgetIntegrationsKeys,
      isInitialized,
      getByCredentials,
      getApiKey,
      widgetCustomStylesLinks,
    }
  },
)
